export default {
  stackOnPhone: {
    '@media screen and (max-width: 600px)': {
      '& > .MuiGrid-item': {
        maxWidth: '100%',
        flexBasis: '100%',
      },
    },
  },
  datePicker: {
    height: '42px',
    '@media screen and (max-width: 600px)': {
      width: '100%',
    },
  },
  datePickerStyles: {
    marginTop: '11px',
    marginBottom: '-6px',
    display: 'flex',
    flexDirection: 'column',
  },
  datePickerText: {
    fontSize: '12px',
  },
  infoText: {
    fontSize: '14px',
    padding: '0px 6px',
  },
};
